<app-accordion [title]="'Contrato de Trabalho'">
  <form [formGroup]="form">
    <div formArrayName="contracts"
         class="contracts">
      <div *ngFor="let item of contracts.controls; let i = index"
           class="form-group">
        <div [formGroupName]="i"
             class="d-flex flex-column border">
          <div class="row my-2 mx-0 p-0">
            <div class="col-md-6 m-0">
              <label class="text-default-label">Título do documento</label>
              <input type="text"
                     [readonly]="isConsult"
                     class="form-control"
                     formControlName="title"
                     [ngClass]="{
                  'is-invalid':
                    getWorkJobContractForm(i).title.errors &&
                    getWorkJobContractForm(i).title.dirty
                }" />

              <div class="invalid-feedback"
                   *ngIf="
                  getWorkJobContractForm(i).title.invalid &&
                  getWorkJobContractForm(i).title.errors
                ">
                <span>O título é obrigatório</span>
              </div>
            </div>

            <div class="col-md-6 m-0">
              <label class="text-default-label">Data de inclusão</label>
              <input type="text"
                     [readonly]="isConsult"
                     class="form-control creation-date"
                     formControlName="creationDate"
                     [ngClass]="{
                  'is-invalid':
                    getWorkJobContractForm(i).creationDate.errors &&
                    getWorkJobContractForm(i).creationDate.dirty
                }" />
              <div class="invalid-feedback"
                   *ngIf="
                  getWorkJobContractForm(i).creationDate.invalid &&
                  getWorkJobContractForm(i).creationDate.errors
                ">
                <span>data de conclusão é obrigatório</span>
              </div>
            </div>
          </div>

          <div class="col-12 m-0">
            <div class="mx-0 my-2 p-0 row justify-content-between">
              <label class="text-default-label">Documento</label>
              <app-upload-file [isExhibition]="isExhibition"
                               [selectedImage]="
                  documentList[i]?.doc &&
                  'data:application/' +
                    documentList[i]?.docExtension +
                    ';base64,' +
                    documentList[i]?.doc
                "
                               (selectFileWithExtension)="getDocument(i, $event)"
                               [isConsult]="isConsult">
              </app-upload-file>
            </div>
            <div class="mx-0 my-2 p-0 row d-flex justify-content-between">
              <div class="col-sm-12 col-md-2 col-lg-2 mx-0 my-1 py-0 px-2">
                <!-- <button
                  class="btn btn-secondary m-1"
                  *ngIf="!isExhibition"
                  (click)="removeWorkJobContract(i)"
                >
                  REMOVER
                </button> -->
              </div>

              <div class="col-md-9 col-lg-9 row col-sm-12 justify-content-end mx-0 my-1 py-0 px-2">
                <button *ngIf="!isConsult"
                        class="btn btn-outline-primary col-sm-12 col-md-2 m-1"
                        (click)="saveForm(i)">
                  SALVAR
                </button>

                <button class="btn btn-outline-secondary text-uppercase col-sm-12 m-1 col-md-5"
                        type="button"
                        (click)="downloadSignedDocument(i)">
                  Baixar o documento
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-100 d-flex justify-content-between my-3"
         *ngIf="!isExhibition && !isConsult">
      <button class="btn btn-outline-primary"
              (click)="addWorkJobContract()">
        ADICIONAR DOCUMENTO
      </button>
    </div>
  </form>
</app-accordion>